

















































import {Vue, Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {GrupeDelovaVozila} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class GrupeDelova extends mixins(ComponentBaseMixin) {
    columns = [];
    grupe = [];
    grupa = new GrupeDelovaVozila();
    tableOptions = {
        search: true,
        pagination: true,
        onClickRow: row => this.onClickRow(row)
    };

    async created() {
        this.columns = [
            {field: 'oznaka', width: 50, title: this.$i18n.t('oznaka')},
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {field: 'preventivnoOdrzavanje', width: 50, title: this.$i18n.t('p')},
            {field: 'korektivnoOdrzavanje', width: 50, title: this.$i18n.t('c')},
        ];
        this.grupe = await this.loadData(() => dataProxy.vratiGrupeDelovaVozila())();
    }

    async sacuvajGrupu() {
        const isFormValid = await (<any>this.$refs.form).validate();
        if (isFormValid) {
            this.grupa = await this.saveData(() => dataProxy.sacuvajGrupuDelovaVozila(this.grupa))();
            this.grupe = await this.loadData(() => dataProxy.vratiGrupeDelovaVozila())();
        }
    }

    onClickRow(row) {
        this.grupa = row;
    }

    async obrisiGrupu() {
        const valid = await this.confirmationNeeded('da li zelite da obrisete grupu delova');
        if (valid) {
            this.grupe = await this.deleteData(() => dataProxy.obrisiGrupuDelovaVozila(this.grupa.id))();
            this.novaGrupa();
        }
    }


    novaGrupa() {
        this.grupa = new GrupeDelovaVozila();
        (<HTMLElement>this.$refs.oznaka).focus();
    }
}
